/* global Sys, Core */
Sys.ns("Core");

Core.loadProgressHandlerReactions = {
    EVENT: {
        LOAD_COMPETED: "loadCompleted",
        LOAD_PROGRESS: "loadProgress"
    },

    createLoadProgressHandler: function(messageApi) {
        var me = this,
            loadCompleted = false;

        return function(progress) {
            if (loadCompleted) {
                return;
            }

            if (progress < 100) {
                messageApi.sendMessageEvent(me.EVENT.LOAD_PROGRESS, { value: progress });
            }
            else {
                messageApi.sendMessageEvent(me.EVENT.LOAD_COMPETED);
                loadCompleted = true;
            }
        };
    },

    createDialogHandler: function(messageApi) {
        var me = this;

        return function(errorData) {
            messageApi.sendMessageEvent("error", { errorCode: me.DEFAULT_ERROR_CODE });
        };
    },

    init: function(loadProgressHandler, messageApi) {
        loadProgressHandler.on("progress", this.createLoadProgressHandler(messageApi));

        loadProgressHandler.on("dialog", this.createDialogHandler(messageApi));
    }
};
